import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=66a43294&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=ts&"
export * from "./mobile.vue?vue&type=script&lang=ts&"
import style0 from "./mobile.vue?vue&type=style&index=0&id=66a43294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a43294",
  null
  
)

export default component.exports